module.exports = __webpack_public_path__ + "assets/img/4.png?8e46d49f09619b7c53dc0b42c331a8cc";